import * as Sentry from "@sentry/vue";
import { API_ENDPOINTS } from "@utils/api/endpoints";

export default async function (idPost, idMessage) {
  const routeLang = useRouteLang();

  try {
    return await $apiFetch(API_ENDPOINTS.CONTENT_POST_ID_MESSAGE_ID_TRANSLATION, {
      method: 'GET',
      path: { idPost, idMessage },
      params: {
        locale: routeLang.locale.value
      }
    });
  } catch (error) {
    Sentry.captureException(error);
  }

  return null;
}
